import React from 'react';
import { Table } from 'reactstrap';
import image from '../../../../../assets/images/static-image.jpg'
import { getImageURL } from '../../../../../snippets/snippets';

const WishlistDetails = ({ wishlist }) => {
  return (
    <div>
      <h4>{wishlist.wishlist_name}</h4>
      <Table responsive>
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Date Added</th>
            <th>Price</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {wishlist.details.map(product => (
            <tr key={product.id}>
              <td>
              <img src={ product.image !== "" ? getImageURL(product.image) : image} 
                        style={{borderRadius:"50%", height:"35px", width:"35px"}} />
                        &ensp;
                        &ensp; 
                {product.productName}
              </td>
              <td>{product.dateAdded}</td>
              <td>{product.price}</td>
              <td>{product.action}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default WishlistDetails;
